<template>
  <section
    id="location"
    v-if="hasMapOrLink || (viewer?.is_owner && ownerViewMode)"
    class="w-full px-4 sm:px-6 pb-12 md:pb-20"
    aria-label="Map"
  >
    <div class="max-w-6xl mx-auto">
      <div v-if="hasMapOrLink">
        <PublicRestaurantMap
          :restaurant="restaurant"
          :show-owner-map-hint="viewer?.is_owner === true"
          container-class="h-[400px] bg-t1-bg-light rounded-lg border border-t1-border"
          link-class="bg-[var(--t1-primary)] text-white hover:opacity-90 focus:ring-[var(--t1-primary)]"
        />
      </div>
      <div v-else-if="viewer?.is_owner && ownerViewMode" class="py-8">
        <div class="py-4 px-4 rounded border border-dashed border-t1-neutral-dark/40 bg-t1-neutral-dark/5 max-w-md">
          <p class="text-sm font-mono text-t1-neutral-dark/70">{{ $t('public.noMapSetOwnerMessage') }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import PublicRestaurantMap from '@/components/public/PublicRestaurantMap.vue'
import { restaurantHasMapOrLink } from '@/utils/googleMapsUrl'

const props = defineProps({
  restaurant: { type: Object, default: () => ({}) },
  viewer: { type: Object, default: () => ({ is_owner: false }) },
  ownerViewMode: { type: Boolean, default: true },
})

const hasMapOrLink = computed(() => restaurantHasMapOrLink(props.restaurant))
</script>
